(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/numbergames/jackpots/assets/javascripts/jackpots.js') >= 0) return;  svs.modules.push('/components/numbergames/jackpots/assets/javascripts/jackpots.js');

'use strict';

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
let format;
let productMapping;
let kenoTypes;
let getKenoLevelWinPlanTopWin;
let getRules;
let rules;
let JACKPOT_WINSET;
let JACKPOT_WINDIV;
if (svs.isServer) {
  const path = require('path');
  const trinidadCore = require('@svenskaspelab/trinidad-core').core;
  format = trinidadCore.components.require('utils', 'format').api;
  productMapping = trinidadCore.components.require('numbergames', 'product-mapping').productMapping;
  var _trinidadCore$compone = trinidadCore.components.require('numbergames', 'rules');
  rules = _trinidadCore$compone.rules;
  getRules = _trinidadCore$compone.getRules;
  kenoTypes = _trinidadCore$compone.kenoTypes;
  getKenoLevelWinPlanTopWin = _trinidadCore$compone.getKenoLevelWinPlanTopWin;
  var _require = require(path.join(__dirname, 'constants.es6'));
  JACKPOT_WINSET = _require.JACKPOT_WINSET;
  JACKPOT_WINDIV = _require.JACKPOT_WINDIV;
} else {
  format = svs.utils.format;
  productMapping = svs.numbergames.productMapping;
  rules = svs.numbergames.rules;
  getRules = svs.numbergames.rules.getRules;
  var _svs$numbergames$rule = svs.numbergames.rules.utils.keno_winplan;
  kenoTypes = _svs$numbergames$rule.types;
  getKenoLevelWinPlanTopWin = _svs$numbergames$rule.getLevelWinPlanTopWin;
  var _svs$numbergames$jack = svs.numbergames.jackpot.CONSTANTS;
  JACKPOT_WINSET = _svs$numbergames$jack.JACKPOT_WINSET;
  JACKPOT_WINDIV = _svs$numbergames$jack.JACKPOT_WINDIV;
}

function kenoTopWin(boards) {
  const kenoRules = getRules({
    productId: productMapping.CONSTANTS.KENO
  });
  if (!Array.isArray(boards)) {
    boards = [boards || {}];
  }
  const topWins = boards.map(board => {
    const _board$kenoLevel = board.kenoLevel,
      kenoLevel = _board$kenoLevel === void 0 ? kenoRules.levels.preset : _board$kenoLevel,
      _board$rowPrice = board.rowPrice,
      rowPrice = _board$rowPrice === void 0 ? kenoRules.rowPrice : _board$rowPrice,
      _board$hasKungKeno = board.hasKungKeno,
      hasKungKeno = _board$hasKungKeno === void 0 ? kenoRules.kungKeno : _board$hasKungKeno,
      systemNumbers = board.systemNumbers,
      isSystem = board.isSystem;
    return getKenoLevelWinPlanTopWin({
      type: isSystem ? kenoTypes.KENO_SYSTEM : kenoTypes.KENO_DEFAULT,
      level: kenoLevel,
      rowPrice,
      systemNumbers,
      hasKungKeno
    });
  });
  const topWin = Math.max(...topWins);
  let topWinText;
  if (boards.some(b => !b.isSystem) && topWin >= 1000000) {
    topWinText = "".concat(format.CurrencyInMillions(topWin), " miljoner");
  } else {
    topWinText = "".concat(format.Currency(topWin), " kr");
  }
  return {
    defaultJackpot: false,
    description: 'Vinn upp till',
    jackpotAmount: topWin,
    jackpotAmountString: topWinText,
    jackpotAmountStringShort: topWinText,
    productName: productMapping.getProductName(productMapping.CONSTANTS.KENO)
  };
}
function getJackpotAmountStrings(jackpot) {
  const formatMillions = amount => amount.replace(/\s/g, '').replace(',', '.') > 1 ? "".concat(amount, " miljoner") : "".concat(amount, " miljon");
  const jackpotAmount = format.CurrencyInMillions(jackpot.jackpotAmount);
  const guaranteedJackpotAmount = format.CurrencyInMillions(jackpot.guaranteedJackpotAmount);
  return {
    jackpotAmountString: formatMillions(jackpotAmount),
    jackpotAmountStringShort: "".concat(jackpotAmount, " milj"),
    guaranteedJackpotAmountString: formatMillions(guaranteedJackpotAmount),
    guaranteedJackpotAmountStringShort: "".concat(guaranteedJackpotAmount, " milj")
  };
}

function getJackpot(_ref) {
  let product = _ref.product,
    description = _ref.description,
    winset = _ref.winset,
    windiv = _ref.windiv,
    _ref$jackpots = _ref.jackpots,
    jackpots = _ref$jackpots === void 0 ? [] : _ref$jackpots,
    drawNumber = _ref.drawNumber,
    kenoBoards = _ref.kenoBoards,
    jokerPrice = _ref.jokerPrice;
  const findJackpot = () => {
    var _filteredJackpots$fin;
    let filteredJackpots = jackpots.filter(j => productMapping.isSameProduct(j.productId, product));
    if (!filteredJackpots.length) {
      filteredJackpots = jackpots.filter(j => productMapping.isSameProduct(j.productName, product));
    }
    if (drawNumber) {
      const filteredByDrawNumber = filteredJackpots.filter(j => j.drawNumber === drawNumber);
      if (filteredByDrawNumber.length) {
        filteredJackpots = filteredByDrawNumber;
      }
    }
    if (description) {
      filteredJackpots = filteredJackpots.filter(j => j.description === description);
    }
    if (Number.isInteger(winset)) {
      filteredJackpots = filteredJackpots.filter(j => j.winset === winset);
    }
    if (Number.isInteger(windiv)) {
      filteredJackpots = filteredJackpots.filter(j => j.windiv === windiv);
    }
    const jackpot = (_filteredJackpots$fin = filteredJackpots.find(j => !j.defaultJackpot)) !== null && _filteredJackpots$fin !== void 0 ? _filteredJackpots$fin : filteredJackpots[0];
    return _objectSpread({}, jackpot);
  };
  const productId = productMapping.getProductId(product);
  let jackpot;
  let jackpotAmountString;
  let jackpotAmountStringShort;
  let guaranteedJackpotAmountString;
  let guaranteedJackpotAmountStringShort;
  let tag = '';
  let guaranteedTag = 'alltid minst';
  let guaranteedTagShort = 'minst';
  switch (productId) {
    case productMapping.CONSTANTS.KENO:
      return kenoTopWin(kenoBoards);
    case productMapping.CONSTANTS.JOKER:
      return {
        jackpotAmount: rules.joker.getTopWin(jokerPrice),
        productName: productMapping.getProductName(product)
      };
    case productMapping.CONSTANTS.LOTTO:
      if (!description) {
        winset !== null && winset !== void 0 ? winset : winset = JACKPOT_WINSET.DROMVINST;
      }
      jackpot = findJackpot();
      if (jackpot) {
        description !== null && description !== void 0 ? description : description = jackpot.description;
        var _getJackpotAmountStri = getJackpotAmountStrings(jackpot);
        jackpotAmountString = _getJackpotAmountStri.jackpotAmountString;
        jackpotAmountStringShort = _getJackpotAmountStri.jackpotAmountStringShort;
        guaranteedJackpotAmountString = _getJackpotAmountStri.guaranteedJackpotAmountString;
        guaranteedJackpotAmountStringShort = _getJackpotAmountStri.guaranteedJackpotAmountStringShort;
        if (jackpot.winset === JACKPOT_WINSET.DROMVINST) {
          tag = 'alltid';
          guaranteedTag = 'alltid';
          guaranteedTagShort = 'alltid';
        } else {
          jackpotAmountString = "ca ".concat(jackpotAmountString);
          jackpotAmountStringShort = "ca ".concat(jackpotAmountStringShort);
        }
      }
      break;
    default:
      windiv !== null && windiv !== void 0 ? windiv : windiv = JACKPOT_WINDIV.PRIMARY;
      jackpot = findJackpot();
      if (jackpot) {
        if (jackpot.windiv === JACKPOT_WINDIV.PRIMARY) {
          description = 'Jackpot';
        }
        var _getJackpotAmountStri2 = getJackpotAmountStrings(jackpot);
        jackpotAmountString = _getJackpotAmountStri2.jackpotAmountString;
        jackpotAmountStringShort = _getJackpotAmountStri2.jackpotAmountStringShort;
        guaranteedJackpotAmountString = _getJackpotAmountStri2.guaranteedJackpotAmountString;
        guaranteedJackpotAmountStringShort = _getJackpotAmountStri2.guaranteedJackpotAmountStringShort;
        jackpotAmountString = "ca ".concat(jackpotAmountString);
        jackpotAmountStringShort = "ca ".concat(jackpotAmountStringShort);
        guaranteedJackpotAmountStringShort = "ca ".concat(guaranteedJackpotAmountStringShort);
      }
  }
  if (!jackpot) {
    return {};
  }
  const guaranteedJackpot = {
    defaultJackpot: true,
    description,
    tag: guaranteedTag,
    tagShort: guaranteedTagShort,
    jackpotAmount: parseInt(jackpot.guaranteedJackpotAmount, 10),
    jackpotAmountString: guaranteedJackpotAmountString,
    jackpotAmountStringShort: guaranteedJackpotAmountStringShort,
    productName: productMapping.getProductName(jackpot.productName)
  };
  if (!productMapping.isProductFamily(product)) {
    if (!productMapping.isSameProduct(jackpot.productId, product)) {
      return guaranteedJackpot;
    }
    if (drawNumber && parseInt(drawNumber, 10) !== jackpot.drawNumber) {
      return guaranteedJackpot;
    }
  }
  return jackpot.defaultJackpot ? guaranteedJackpot : {
    defaultJackpot: jackpot.defaultJackpot,
    description,
    tag,
    tagShort: tag,
    jackpotAmount: parseInt(jackpot.jackpotAmount, 10),
    jackpotAmountString,
    jackpotAmountStringShort,
    productName: productMapping.getProductName(jackpot.productName)
  };
}
if (svs.isServer) {
  module.exports = {
    getJackpot
  };
} else {
  svs.numbergames.jackpot.getJackpot = getJackpot;
}

 })(window);